module.exports = __webpack_public_path__ + "static/img/3.8a4e167.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/companyLogo-f/3.jpg
// module id = Y5RT
// module chunks = 0